import React, { useEffect, useState } from "react";
import { Button, Paper, Typography } from "@mui/material";

const DisplayTimeline = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [eras, setEras] = useState([]);
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/enterprise/history/eras`)
      .then((r) => r.json())
      .then((res) => setEras(res.data));
  }, []);

  const loadNodes = async (id) => {
    const res = await fetch(`${API_URL}/enterprise/history/nodes?eraId=${id}`);
    const result = await res.json();
    setNodes(result.data);
  };

  return (
    <div>
      {eras?.map((e) => (
        <Button key={e.id} onClick={() => loadNodes(e.id)}>
          {e.title}
        </Button>
      ))}

      {nodes.map((n) => (
        <Paper key={n.id} sx={{ p: 1, mt: 1 }}>
          <Typography>
            <b>{n.year}</b> - {n.title}
          </Typography>
        </Paper>
      ))}
    </div>
  );
};

export default DisplayTimeline;
